import { render } from "./TipoEspaco.vue?vue&type=template&id=b2a3ec22"
import script from "./TipoEspaco.vue?vue&type=script&lang=js"
export * from "./TipoEspaco.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__